"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const expiredBannerTranslations_json_1 = __importDefault(require("./expiredBannerTranslations/expiredBannerTranslations.json"));
require("./expiredBanner.scss");
const styled_components_1 = __importDefault(require("styled-components"));
const master_1 = require("../../../constants/master");
const StyledExpiredBanner = styled_components_1.default.div `
  background: ${(props) => props.primaryColor} !important;
  color: white !important;
`;
function ExpiredBanner(props) {
    props.addTranslation(expiredBannerTranslations_json_1.default);
    const config = (0, master_1.getMasterConfig)();
    return (react_1.default.createElement(StyledExpiredBanner, { primaryColor: config.primaryColor, id: "expired-banner" }, props.details.isExpired ? (react_1.default.createElement("span", { className: "expired-text" },
        props.translate("expiredOn").toString(),
        props.expireDatePlain.split("T")[0],
        props.translate("noLongerValid").toString())) : (react_1.default.createElement("span", { className: "expiredText" }, props.translate("testCredInfo").toString()))));
}
exports.default = ExpiredBanner;
